import { IData } from '../Shared/common';
import { IComponent } from '../Shared/common';
import { observable, Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { IServerResponse } from '../Shared/common';
import { DBOperation, DataStatus } from '../Shared/enum';
import { IService } from '../Shared/common';
import { User } from '../Models/FitnessBox/User';
import { Organisation } from '../Models/Common/Organisation';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
/*import { Observable } from 'rxjs-compat';*/

Injectable()
export class Global {
  //    public static BASE_USER_ENDPOINT = 'http://localhost:1003/api/StockData';

  public static Base_Domain = "http://localhost:2001/";
  public static BASE_USER_ENDPOINT(): string {
    //return "https://admin.iconfitnessindia.com/service/api/";
    if (window.location?.origin) {
      return window.location.origin + "/service/api/";
    }
    else {
      return Global.Base_Domain + 'service/api/';
    }
  };

  public static relativeTempUploadPath(): string {
    if (window.location?.origin) {
      return window.location.origin + "/service/Data/TempUpload/";
    }
    else {
      return Global.Base_Domain + 'service/Data/TempUpload/';
    }
  };

  //public static BASE_USER_ENDPOINT = Global.Base_Domain + 'service/api/';
  //public static relativeTempUploadPath = Global.Base_Domain + "service/Data/TempUpload/";
  public static fileVersion = '?tmplv=' + Date.now();
  public static maxRowsForServerFetch = 55;

  public static DefaultPage = '/home';
  public static ProductController = 'StockData/';
  public static CategoryController = 'Categories/';
  public static ChildCategoryController = 'Categories/ChildCategories/';
  public static ChildCategoryByNameController = 'Categories/GetChildCategoriesByName/';
  public static TaxController = 'Tax/';
  public static ScreensController = 'Screens/';
  public static CountryController = 'Country/';
  public static StorageLocationController = 'StorageLocation/';
  public static PartyController = 'Party/';
  public static AddressController = 'Address/';
  public static ManufacturerController = 'Manufacturer/';
  public static BrandController = 'Brand/';
  public static FileUploadController = 'Upload/';
  public static SettingsController = 'Settings/';
  public static AppSettingsController = 'settings/app-settings/';
  public static CommonSettingsController = 'settings/common-settings/';
  public static TransactionsController = 'Transactions/';
  public static PermissionController = 'Permissions/';
  public static UserController = 'User/';
  public static UsersBirthdayEndpoint = this.UserController + 'birthday-users?fromDate={0}&toDate={1}';
  public static NotificationsController = 'Notifications/';
  public static NotificationsListEndpoint = this.NotificationsController + 'notification-list';

  //Search APIs
  public static ProductSearchApi = 'StockData/Search';
  public static CategorySearchApi = 'Categories/Search';
  public static TaxSearchApi = 'Tax/Search';
  public static CountrySearchApi = 'Country/Search';
  public static StorageLocationSearchApi = 'StorageLocation/Search';
  public static CustomerSearchApi = 'Party/SearchCustomer';
  public static DistributorSearchApi = 'Party/SearchDistributor';
  public static BrandSearchApi = 'Brand/Search';
  public static InvoiceTemplateSetting = 'Settings/GetActiveInvoiceTemplate';

  public static UserSearchApi = 'User/Search';
  public static UserDataApi = 'User/GetUserData';
  public static EmployeeContractorSearch = 'EmployeeContractor/Search';
  public static EmployeeToAutoAssign = 'EmployeeContractor/GetAutoAssignStaff?filter={0}&datatype={1}';
  public static GetCommonData = 'Common/GetCommonData?filter={0}&datatype={1}';
  //FitnessBox
  public static MemberController = 'Member/';
  public static MembershipPlanController = 'MembershipPlan/';
  public static EmployeeContractorController = 'EmployeeContractor/';
  public static MemberSaveController = 'Member/SaveMember';
  public static MemberSearchApi = 'Member/Search';
  public static MembershipPlanSearchApi = 'MembershipPlan/MembershipPlanSearch';
  public static UserMembershipPlanSearchApi = 'Member/UserMembershipPlanSearch';
  public static MemberExistingUserSearchApi = 'Member/CheckIfUserExists';
  public static UserMembershipPlanTemplateSearchApi = 'UserMembershipPlan/UserMembershipPlanTemplateSearch';
  public static BodyPartSearchApi = 'Common/BodyPartSearch';
  public static MeasurementUnitSearchApi = 'Common/MeasurementUnitSearch';
  public static GenderSearchApi = 'Common/GenderSearch';
  public static SubscriptionController = 'Subscription/';
  public static ApplicationController = 'Application/';
  public static DashboardController = 'Dashboard/';
  public static GuestMemberController = 'GuestMember/';
  public static GuestToMemberConvertController = 'GuestMember/convert-to-member';
  public static SubscriptionReportController = 'SubscriptionReport/';
  public static MemberReportController = "MemberReport/";
  public static SlideShowController = 'SlideShow/';
  public static StaffPayoutController = 'StaffPayout/';
  public static EmployeePayoutController = 'EmployeePayout/';
  public static AttendanceController = 'Attendance/';
  public static PtAttendanceEndpoint = this.AttendanceController + 'pt-attendance-logs';

  public static ReminderTypesController = 'ReminderTypes/';
  public static ReminderTypesListEndpoint = Global.ReminderTypesController + 'typelist';
  public static ReminderSubTypesListEndpoint = Global.ReminderTypesController + 'subtypelist';
  public static ReminderResponseTypesListEndpoint = Global.ReminderTypesController + 'responsetypelist';
  public static ActivityController = "Workout/Activity/";
  public static ActivityTypeController = "Workout/ActivityType/";
  public static ActivityFormatController = "Workout/ActivityFormat/";
  public static EquipmentTypeController = "Workout/EquipmentType/";
  public static EquipmentController = "Workout/Equipment/";
  public static MuscleGroupController = "Workout/MuscleGroup/";
  public static MuscleGroupCategoryController = "Workout/MuscleGroupCategory/";
  public static RoutineController = "Workout/Routine/";
  public static RoutineSeriesController = "Workout/RoutineSeries/";
  public static ExerciseUnitChangeTypeController = "Workout/UnitChangeType/";
  public static TrainingProtocolController = "Workout/TrainingProtocol/"

  //Collections
  public static FitnessGoalController = "Collection/FitnessGoal/";
  public static EquipmentConditionController = "Collection/EquipmentCondition/";
  public static OperationalStatusController = "Collection/OperationalStatus/";

  //Org and Auth
  public static AuthController = 'Auth/';
  public static OrgController = 'Org/';
  public static OrgValidationController = 'Role/';

  public static CurrentUser: User = null;
  public static CurrentOrg: Organisation = null;

  public static IsConsoleLogEnabled: boolean = true;

  static getParameters(id: number, perpage: number, p: number, r: number, all: boolean, filter: string, sort: string, onlyActive: boolean = true, type: string = ""): string {
    onlyActive = (onlyActive != undefined && onlyActive != null) ? onlyActive : true;
    if (type != undefined && type != null && type != "") {

      return "?Id=" + id + "&perpage=" + perpage + "&pageNumber=" + p + "&rowsToHold=" + r + "&all=" + all + "&filter=" + filter + "&sort=" + sort + "&onlyActive=" + onlyActive + "&type=" + type;
    }
    else {
      return "?Id=" + id + "&perpage=" + perpage + "&pageNumber=" + p + "&rowsToHold=" + r + "&all=" + all + "&filter=" + filter + "&sort=" + sort + "&onlyActive=" + onlyActive;
    }

  }

  static getSearchParameters(r: number, all: boolean, filter: string): string {
    return "?rowsToShow=" + r + "&all=" + all + "&filter=" + filter;
  }

  static getSingleItemParameters(id: number): string {
    return "?Id=" + id;
  }

  static getDataFilterParameters(fromDate: Date, toDate: Date, perpage: number, p: number, r: number, all: boolean, filter: string, sort: string, onlyActive: boolean = true, type: string = ""): string {
    onlyActive = (onlyActive != undefined && onlyActive != null) ? onlyActive : true;
    if (type != undefined && type != null && type != "") {
      return "?fromDate=" + fromDate.toLocaleDateString('en-GB') + "&toDate=" + toDate.toLocaleDateString('en-GB') + "&perpage=" + perpage + "&pageNumber=" + p + "&rowsToHold=" + r + "&all=" + all + "&filter=" + filter + "&sort=" + sort + "&onlyActive=" + onlyActive + "&type=" + type;
    }
    else {
      return "?fromDate=" + fromDate.toLocaleDateString('en-GB') + "&toDate=" + toDate.toLocaleDateString('en-GB') + "&perpage=" + perpage + "&pageNumber=" + p + "&rowsToHold=" + r + "&all=" + all + "&filter=" + filter + "&sort=" + sort + "&onlyActive=" + onlyActive;
    }
  }

  static getDataFilterParametersWithId(id: number, fromDate: Date, toDate: Date, perpage: number, p: number, r: number, all: boolean, filter: string, sort: string, onlyActive: boolean = true, type: string = ""): string {
    onlyActive = (onlyActive != undefined && onlyActive != null) ? onlyActive : true;
    if (type != undefined && type != null && type != "") {
      return "?Id=" + id + "&fromDate=" + fromDate.toLocaleDateString('en-GB') + "&toDate=" + toDate.toLocaleDateString('en-GB') + "&perpage=" + perpage + "&pageNumber=" + p + "&rowsToHold=" + r + "&all=" + all + "&filter=" + filter + "&sort=" + sort + "&onlyActive=" + onlyActive + "&type=" + type;
    }
    else {
      return "?Id=" + id + "&fromDate=" + fromDate.toLocaleDateString('en-GB') + "&toDate=" + toDate.toLocaleDateString('en-GB') + "&perpage=" + perpage + "&pageNumber=" + p + "&rowsToHold=" + r + "&all=" + all + "&filter=" + filter + "&sort=" + sort + "&onlyActive=" + onlyActive;
    }
  }

  static getPage(page: number, component: IComponent, dataList: any[]) {
    if (page.toString() == 'NaN') {
      page = 1;
    }
    component.loading = true;
    component.isDataRefreshed = true;
    var observableRes = Global.serverCall(dataList, page, component.perPage, component);

    if (observableRes != undefined && observableRes != null) {
      return observableRes
        .pipe(
          tap(res => {
            //this.total = res.total;
            component.pageNum = page;
            component.loading = false;
          }),
          map(res => res.items)
        );


      //return observableRes
      //  .do(res => {
      //    //this.total = res.total;
      //    component.pageNum = page;
      //    component.loading = false;
      //  })
      //  .map(res => res.items);
    }
    else {
      return null;
    }

  }

  static serverCall(data: IData[], page: number, perPage: number, component: IComponent): Observable<IServerResponse> {
    var realStart: number = (page - 1) * perPage;
    var realEnd: number = realStart + perPage;
    if (data.length > 0) {
      var start: number = (realStart - (data[0].RowNumber - 1));
      var end: number = start + perPage;

      var needServerRefresh: boolean = false;
      //var hold: number = Global.maxRowsForServerFetch;
      //var chunkNumber: number = 1;
      //chunkNumber = Math.ceil(((page * perPage) / hold));
      //if (end > (hold * chunkNumber) || start <= ((hold * chunkNumber) - hold)) {
      if ((realEnd > data[data.length - 1].RowNumber || realStart < (data[0].RowNumber - 1)) && realStart != data[0].RowNumber && !(component.total < realEnd)) {
        //fetch data from serer if the requested page data falls outside the bounds of Cached List
        needServerRefresh = true;
      }
      if (needServerRefresh) {
        component.Load(perPage, page, Global.maxRowsForServerFetch);
      }
      else {
        return
        of({
          items: data.slice(start, end),
          total: component.total
        });//.delay(1000);
      }
    }
  }

  static onSubmit(formData: any, component: IComponent, service: IService, controllerName: string, refreshComponentList: boolean, callback: Function) {
    component.msg = "";
    component.dataStatus = DataStatus.FAILED;
    switch (component.dbops) {
      case DBOperation.create:
        service.post(Global.BASE_USER_ENDPOINT() + controllerName, formData.value).subscribe(
          data => {
            if (data == 1) //Success
            {
              if (callback != null) {
                callback(data);
              }
              else {
                component.msg = "Data successfully added.";
                component.dataStatus = DataStatus.SUCCESS;
                if (refreshComponentList) {
                  component.Load(component.perPage, component.pageNum, Global.maxRowsForServerFetch);
                  setTimeout(function () {
                    formData.reset();
                    component.modal.close('modal');
                  }, 2000);
                }
              }

            }
            else {
              component.msg = "There is some issue in saving records, please contact to system administrator!"
            }

            //this.modal.dismiss();
          },
          error => {
            component.msg = error;
          }
        );
        break;
      case DBOperation.update:
        service.put(Global.BASE_USER_ENDPOINT() + controllerName, formData.value.ID, formData.value).subscribe(
          data => {
            if (data == 1 || (data != undefined && data != null && data != 0)) //Success
            {
              if (callback != null) {
                callback(data);
              }
              else {
                component.msg = "Data successfully updated.";
                component.dataStatus = DataStatus.SUCCESS;
                if (refreshComponentList) {
                  component.Load(component.perPage, component.pageNum, Global.maxRowsForServerFetch);
                  setTimeout(function () {
                    formData.reset();
                    component.modal.close('modal');
                  }, 2000);
                }
              }
            }
            else {
              component.msg = "There is some issue in saving records, please contact to system administrator!"
            }

            //this.modal.dismiss();
          },
          error => {
            component.msg = error;
          }
        );
        break;
      case DBOperation.delete:
        service.delete(Global.BASE_USER_ENDPOINT() + controllerName, formData.value.ID).subscribe(
          data => {
            if (data == 1) //Success
            {
              if (callback != null) {
                callback(data);
              }
              else {
                component.msg = "Data successfully deleted.";
                component.dataStatus = DataStatus.SUCCESS;
                if (refreshComponentList) {
                  component.Load(component.perPage, component.pageNum, Global.maxRowsForServerFetch);
                  component.modal.close('modal');
                }
              }
            }
            else {
              component.msg = "There is some issue in saving records, please contact to system administrator!"
            }

            //this.modal.dismiss();
          },
          error => {
            component.msg = error;
          }
        );
        break;

    }
  }

  static onSubmitData(formData: any, dbops: DBOperation, service: IService, endpoint: string, callback: Function, ctx: any) {
    switch (dbops) {
      case DBOperation.create:
        service.post(endpoint, formData).subscribe(
          data => {
            if (data == 1 || (data != undefined && data != null && data != 0)) //Success
            {
              if (callback != null) {
                if (ctx != null) {
                  callback(data, ctx);
                }
                else {
                  callback(data);
                }
              }
            }
            else {
              //throw "Failed";
              callback(null, ctx);
            }
          },
          error => {
            throw error;
          }
        );
        break;
      case DBOperation.update:
        service.put(endpoint, formData.ID, formData).subscribe(
          data => {
            if (data == 1 || (data != undefined && data != null && data != 0)) //Success
            {
              if (callback != null) {
                if (ctx != null) {
                  callback(data, ctx);
                }
                else {
                  callback(data);
                }
              }
            }
            else {
              //throw "Failed";
              callback(null, ctx);
            }
          },
          error => {
            throw error;
          }
        );
        break;
      case DBOperation.delete:
        service.delete(endpoint, formData.ID).subscribe(
          data => {
            if (data == 1 || (data != undefined && data != null && data != 0)) //Success
            {
              if (callback != null) {
                if (ctx != null) {
                  callback(data, ctx);
                }
                else {
                  callback(data);
                }
              }
            }
            else {
              //throw "Failed";
              callback(null, ctx);
            }
          },
          error => {
            throw error;
          }
        );
        break;

    }
  }

  static limitedAssign<T, S>(source: any, destination: S): void {
    for (var prop in destination) {
      if (source[prop] && destination.hasOwnProperty(prop)) {
        destination[prop] = source[prop];
      }
    }
  }

  static roundOff = (num, places) => {
    const x = Math.pow(10, places);
    return Math.round(num * x) / x;
  }

  static parseDecimal = (num) => {
    try {
      return (num != undefined && num != null && num != "" ? parseFloat(num) : 0);
    } catch (e) {
      return 0;
    }
  }

  static parseInteger = (num) => {
    try {
      return (num != undefined && num != null && num != "" ? parseInt(num) : 0);
    } catch (e) {
      return 0;
    }
  }

  static TransformDateObject(d) {
    if (d != undefined && d != null)
      d = new Date(d);

    if ((<Date>d).getFullYear() == 1)
      d = new Date();

    return d;
  }

  static AdjustDateForTimeOffset(dateToAdjust) {
    var offsetMs = dateToAdjust.getTimezoneOffset() * 60000;
    return new Date(dateToAdjust.getTime() - offsetMs);
  }

  static compareObjects(o1: any, o2: any): boolean {
    if (o1 == undefined || o2 == undefined) {
      return !(o1 == undefined || o2 == undefined);
    }
    else if (o1.name == undefined && o1.id == undefined && o1.Name == undefined && o1.ID == undefined) {
      return o1 == o2;
    }
    else {
      return ((o1.name != undefined && o1.id != undefined && o1.name === o2.name && o1.id === o2.id)
        || (o1.Name != undefined && o1.ID != undefined && o1.Name === o2.Name && o1.ID === o2.ID));
    }
  }


  static StringFormat = (str: string, ...args: string[]) =>
    str.replace(/{(\d+)}/g, (match, index) => args[index] || '');

  static removeByKey<T, K extends keyof T>(array: T[], key: K, value: T[K]): T[] {
    return array.filter(item => item[key] !== value);
  }

  static removeById<T extends { id: number }>(array: T[], id: number): T[] {
    return array.filter(item => item.id !== id);
  }

  static removeById_Mutable<T extends { ID: number }>(array: T[], id: number) {
    const index = array.findIndex(o => o.ID === id);

    if (index !== -1) {
      array.splice(index, 1);
    }
  }

  static Log(message: any, ...optionalParams: any[]) {
    if (Global.IsConsoleLogEnabled) {
      console.log(message, ...optionalParams);
    }
  }

  static LogError(message: any, ...optionalParams: any[]) {
    if (Global.IsConsoleLogEnabled) {
      console.error(message, ...optionalParams);
    }
  }

  static LogWarning(message: any, ...optionalParams: any[]) {
    if (Global.IsConsoleLogEnabled) {
      console.warn(message, ...optionalParams);
    }
  }

  static RedirectTo(router: Router, path: string) {
    // Check if the path contains a query string
    if (path.includes('?')) {
      const [basePath, queryString] = path.split('?');

      // Parse the query string into a key-value object
      const urlParams = new URLSearchParams(queryString);
      const queryParams: { [key: string]: string } = {};

      urlParams.forEach((value, key) => {
        queryParams[key] = value;
      });

      // Navigate using the clean base path and the extracted parameters
      router.navigate([basePath], { queryParams: queryParams });
    } else {
      // Fallback for paths without any query parameters
      router.navigate([path]);
    }
  }

}


const group = (items, fn) => items.reduce((prev, next) => {
  const prop = fn(next);
  return {
    ...prev,
    [prop]: prev[prop] ? [...prev[prop], next] : [next],
  };
}, {});

// UnUsed Code Samples
type DeepClone<T> =
  T extends undefined | null | boolean | string | number ? T :
  T extends Function | Set<any> | Map<any, any> ? unknown :
  T extends ReadonlyArray<infer U> ? Array<DeepClone<U>> :
  { [K in keyof T]: DeepClone<T[K]> };

function deepClone<T>(obj: T): DeepClone<T> {
  // implementation doesn't matter, just use the simplest
  return JSON.parse(JSON.stringify(obj));
}

const deepCopy = <T, U = T extends Array<infer V> ? V : never>(source: T): T => {
  if (Array.isArray(source)) {
    return source.map(item => (deepCopy(item))) as T & U[]
  }
  if (source instanceof Date) {
    return new Date(source.getTime()) as T & Date
  }
  if (source && typeof source === 'object') {
    return (Object.getOwnPropertyNames(source) as (keyof T)[]).reduce<T>((o, prop) => {
      Object.defineProperty(o, prop, Object.getOwnPropertyDescriptor(source, prop)!)
      o[prop] = deepCopy(source[prop])
      return o
    }, Object.create(Object.getPrototypeOf(source)))
  }
  return source
}
